import { zeitFilter } from './zeitTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../app/store';
const initialState: zeitFilter = {
    startDatum: new Date(),
    startDatumTemp: new Date(),
    startDatumVorher: new Date(),
    endeDatum: new Date(),
    endeDatumTemp: new Date(),
    endeDatumVorher: new Date(),
    startCounter: 0,
    startCounterTemp: 0,
    startCounterVorher: 0,
    startZeitraum: "Wochen",
    startZeitraumTemp: "Wochen",
    startZeitraumVorher: "Wochen",
    endeCounter: 0,
    endeCounterTemp: 0,
    endeCounterVorher: 0,
    endeZeitraum: "Wochen",
    endeZeitraumTemp: "Wochen",
    endeZeitraumVorher: "Wochen",
    isChanged: false,
    loading: false,

    error: [],
}

const zeitFilterSlice = createSlice({
    name: "zeit",
    initialState,
    reducers: {
        setStartDatum: (state) => {
            state.startDatumVorher = state.startDatumTemp;
            state.startDatum = state.startDatumTemp;
        },
        setStartDatumTemp: (state, action: PayloadAction<Date>) => {
            state.startDatumTemp = action.payload;
        },
        resetStartDatum: (state) => {
            state.startDatumTemp = state.startDatumVorher;
            state.startDatum = state.startDatumVorher;
        },
        setEndeDatum: (state) => {
            state.endeDatumVorher = state.endeDatumTemp;
            state.endeDatum = state.endeDatumTemp;
        },
        setEndeDatumTemp: (state, action: PayloadAction<Date>) => {
            state.endeDatumTemp = action.payload;
        },
        resetEndeDatum: (state) => {
            state.endeDatumTemp = state.endeDatumVorher;
            state.endeDatum = state.endeDatumVorher;
        },
        setStartCounter: (state) => {
            state.startCounterVorher = state.startCounterTemp;
            state.startCounter = state.startCounterTemp;
        },
        setStartCounterTemp: (state, action: PayloadAction<number>) => {
            state.startCounterTemp = action.payload;
        },
        resetStartCounter: (state) => {
            state.startCounterTemp = state.startCounterVorher;
            state.startCounter = state.startCounterVorher;
        },
        setEndeCounter: (state) => {
            state.endeCounterVorher = state.endeCounterTemp;
            state.endeCounter = state.endeCounterTemp;
        },
        setEndeCounterTemp: (state, action: PayloadAction<number>) => {
            state.endeCounterTemp = action.payload;
        },
        resetEndeCounter: (state) => {
            state.endeCounterTemp = state.endeCounterVorher;
            state.endeCounter = state.endeCounterVorher;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
        handleIncrementStart: (state) => {
            state.startCounterTemp = state.startCounterTemp + 1;
        },
        handleDecrementStart: (state) => {
            state.startCounterTemp = state.startCounterTemp - 1;
        },
        handleIncrementEnde: (state) => {
            state.endeCounterTemp = state.endeCounterTemp + 1;
        },
        handleDecrementEnde: (state) => {
            state.endeCounterTemp = state.endeCounterTemp - 1;
        },
        setError: (state, action: PayloadAction<string>) => {
            if (!state.error.includes(action.payload)) {
                state.error.push(action.payload);
            }
        },
        resetError: (state, action: PayloadAction<string>) => {
            if (state.error.includes(action.payload)) {
                state.error.splice(state.error.indexOf(action.payload), 1)
            }
        },
        switchStartZeitraum: (state) => {
            switch (state.startZeitraumTemp) {
                case "Wochen":
                    state.startZeitraumTemp = "Tage";
                    break;
                case "Tage":
                    state.startZeitraumTemp = "Wochen"
                    break;      
            }
        },
        switchStartZeitraumJahre: (state) => {
            switch (state.startZeitraumTemp) {
                case "Wochen":
                    state.startZeitraumTemp = "Jahre";
                    break;    
                case "Jahre":
                    state.startZeitraumTemp = "Wochen"
                    break;       
            }
        },
        setStartZeitraum: (state) => {
            state.startZeitraumVorher = state.startZeitraumTemp;
            state.startZeitraum = state.startZeitraumTemp;
        },
        resetStartZeitraum: (state) => {
            state.startZeitraumTemp = state.startZeitraumVorher;
            state.startZeitraum = state.startZeitraumVorher;
        },
        switchEndeZeitraum: (state) => {
            switch (state.endeZeitraumTemp) {              
                case "Wochen":
                    state.endeZeitraumTemp = "Tage";
                    break;
                case "Tage":
                    state.endeZeitraumTemp = "Wochen"
                    break;
                         
            }
        },
        switchEndeZeitraumJahre: (state) => {
            switch (state.endeZeitraumTemp) {             
                case "Wochen":
                    state.endeZeitraumTemp = "Jahre";
                    break;    
                case "Jahre":
                    state.endeZeitraumTemp = "Wochen"
                    break;         
            }
        },
        setEndeZeitraum: (state) => {
            state.endeZeitraumVorher = state.endeZeitraumTemp;
            state.endeZeitraum = state.endeZeitraumTemp;
        },
        resetEndeZeitraum: (state) => {
            state.endeZeitraumTemp = state.endeZeitraumVorher;
            state.endeZeitraum = state.endeZeitraumVorher;
        },
        calculateStartDatum: (state) => {
            const now = new Date();
            switch (state.startZeitraumTemp) {
                case "Jahre":
                    state.startDatumTemp = new Date(now.setDate(now.getDate() + Number(state.startCounterTemp) * 365));
                    break;
                case "Wochen":
                    state.startDatumTemp = new Date(now.setDate(now.getDate() + Number(state.startCounterTemp) * 7));
                    break;
                case "Tage":
                    state.startDatumTemp = new Date(now.setDate(now.getDate() + Number(state.startCounterTemp)));
                    break;
            }
        },
        calculateEndeDatum: (state) => {
            const startDate = new Date(state.startDatumTemp);
            switch (state.endeZeitraumTemp) {
                case "Jahre":
                    state.endeDatumTemp = new Date(startDate.setDate(startDate.getDate() + Number(state.endeCounterTemp) * 365));
                    break;
                case "Wochen":
                    state.endeDatumTemp = new Date(startDate.setDate(startDate.getDate() + Number(state.endeCounterTemp) * 7));
                    break;
                case "Tage":
                    state.endeDatumTemp = new Date(startDate.setDate(startDate.getDate() + Number(state.endeCounterTemp)));
                    break;
            }
        },
        setIsChangedZeit: (state, action: PayloadAction<boolean>) => {
            state.isChanged = action.payload;
        }
    }
});

export const {
    setStartDatum,
    setStartDatumTemp,
    resetStartDatum,
    setEndeDatum,
    resetEndeDatum,
    setStartCounter,
    setStartCounterTemp,
    resetStartCounter,
    setEndeCounter,
    setEndeCounterTemp,
    resetEndeCounter,
    setLoading,
    handleIncrementStart,
    handleDecrementStart,
    handleDecrementEnde,
    handleIncrementEnde,
    switchStartZeitraum,
    switchStartZeitraumJahre,
    setStartZeitraum,
    resetStartZeitraum,
    switchEndeZeitraum,
    switchEndeZeitraumJahre,
    setEndeZeitraum,
    resetEndeZeitraum,
    calculateStartDatum,
    calculateEndeDatum,
    setError,
    resetError,
    setIsChangedZeit
} = zeitFilterSlice.actions

export const selectStartDatum = (state: RootState): Date => state.zeit.startDatum;
export const selectStartDatumTemp = (state: RootState): Date => state.zeit.startDatumTemp;
export const selectEndeDatum = (state: RootState): Date => state.zeit.endeDatum;
export const selectEndeDatumTemp = (state: RootState): Date => state.zeit.endeDatumTemp;
export const selectStartCounter = (state: RootState): number => state.zeit.startCounter;
export const selectStartCounterTemp = (state: RootState): number => state.zeit.startCounterTemp;
export const selectEndeCounterTemp = (state: RootState): number => state.zeit.endeCounterTemp;
export const selectEndeCounter = (state: RootState): number => state.zeit.endeCounter;
export const selectStartZeitraum = (state: RootState): string => state.zeit.startZeitraum;
export const selectStartZeitraumTemp = (state: RootState): string => state.zeit.startZeitraumTemp;
export const selectEndeZeitraum = (state: RootState): string => state.zeit.endeZeitraum;
export const selectEndeZeitraumTemp = (state: RootState): string => state.zeit.endeZeitraumTemp;
export const selectIsChangedZeit = (state: RootState): boolean => state.zeit.isChanged;
export const selectError = (state: RootState): boolean => state.zeit.error.length > 0;
export const selectMessstellenLoadingLookup = (state: RootState): boolean => state.messstellenLookup.messstellenLoading;

export default zeitFilterSlice.reducer